// 当前前台是否为开发模式
const isDev = process.env.NODE_ENV === 'development'
let apiUrl = 'http://192.168.0.86:8810'
// if (isDev) apiUrl += '/'
const devOosUrl = 'http://192.168.229.128:9000'
// const devOosUrl = 'https://dgf-bk.oss-cn-guangzhou.aliyuncs.com'
const proOosUrl = 'https://image.dagefan.com'

module.exports = {
    apiUrl: isDev ? apiUrl : '/api/',
    oosUrl: isDev ? devOosUrl : proOosUrl,
    parentDeptId: '10000000364',
    managerDeptId: ['10000000361','10000000363','10000000364','10000000376'],
    firstTag: {
        path: '/dashboard',
        fullPath: '/dashboard',
        name: 'dashboard',
        meta: {tag: '工作台'}
    }
}

